import type { ValueRepresentation } from '../../core/types/scales.js';

/**
 * Resolves the effective valueRepresentation using "any-relative-wins":
 * returns 'relative' if any value is 'relative', otherwise 'absolute'.
 */
export function resolveValueRepresentation(
  ...values: (ValueRepresentation | undefined)[]
): ValueRepresentation {
  return values.includes('relative') ? 'relative' : 'absolute';
}
